// extracted by mini-css-extract-plugin
module.exports = {"container":"RoundedButton_container__1OzYq","icon":"RoundedButton_icon__3ZZAb","title":"RoundedButton_title__2QRRm"};